export default "__VITE_ASSET__CfsNoEBk__"